
  import { Component, Vue } from 'vue-property-decorator';
  import { mapGetters } from 'vuex';

  import errorsService from '@/services/errors.service';
  import accountService from '../../services/account.service';

  @Component({
    computed: {
      ...mapGetters([
        'isLoading'
      ])
    }
  })
  export default class UpdateEmailRecovery extends Vue {
    created() {
      if (this.$route.query.uid) {
        this.updateEmailRecovery();
      }
    }

    updateEmailRecovery() {
      this.$store.dispatch("updateIsLoading", true);

      const url: string = this.$data.RCEnvironment.VUE_APP_ACCOUNT_API_URL + "email/update-email-recovery";

      accountService.get(this, url, { params: this.$route.query })
        .then(() => {
          this.$store.dispatch("updateIsLoading", false);
          this.$router.push({ name: 'UpdateEmailSuccess' });
        })
        .catch(error => {
          errorsService.handleErrors(this, error);
          this.$store.dispatch("updateIsLoading", false);
        });
    }
  }
